module.exports = __webpack_public_path__ + "img/contributionplanner-howitworks1.87b022c1.svg";